export default __webpack_public_path__ + "static/media/help.91c03186.svg";